import type { Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import { type PaymentButtonManager, currencyEventBus, nonProfitEventBus } from '../managers';

export class PricingConfiguratorController {
  public listeners: Listeners;

  constructor(private paymentButtonManager: PaymentButtonManager) {
    this.listeners = controllerHelpers.createListeners([
      currencyEventBus.bindTo('currencyIsChanging', this.onIsLoading),
      nonProfitEventBus.bindTo('nonProfitIsChanging', this.onIsLoading),
    ]);
  }

  private onIsLoading = (isChanging: boolean) => {
    this.paymentButtonManager.getApiWhenReady().then((api) => {
      if (isChanging) {
        api.disable();
      } else {
        api.enable();
      }
    });
  };
}
